import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AccountServiceWebProvider } from '@web-services/user/account.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountDataServiceProvider } from '@services/user/account.data.service';
import { AccessTokens } from '@models/models';
import { UserLoginPayload } from '@models/two-fa.models';
import { finalize, takeUntil } from 'rxjs/operators';
import { MessageService } from '@services/helpers/message-service/message.service';
import { TwoFaAuthenticationService } from '@services/user/two-fa-authentication.service';
import { AuthTokensService } from '../../../../auth-tokens.service';

@Component({
	selector: 'two-fa-setup',
	template: require('./two-fa-login-modal.html'),
	styles: [require('./two-fa-login-modal.scss')]
})
export class TwoFaLoginModalComponent implements OnDestroy {
	@Input() userPayload: UserLoginPayload;

	verificationCode: string;
	buttonDisable: boolean;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private accountService: AccountServiceWebProvider,
		private accountDataService: AccountDataServiceProvider,
		private authTokenService: AuthTokensService,
		private activeModal: NgbActiveModal,
		private messageService: MessageService,
		private twoFaAuthenticationService: TwoFaAuthenticationService
	) {}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	performLogin(): void {
		if (
			this.twoFaAuthenticationService.isTwoFaLoginInfoValid(
				this.verificationCode
			)
		) {
			this.userPayload.userData.sixDigitVerificationCode = this.verificationCode;
			this.buttonDisable = true;
			this.accountDataService
				.authenticateWithTwoFa(
					this.userPayload.userData,
					this.userPayload.authorizationKey
				)
				.pipe(
					takeUntil(this.unsubscribe),
					finalize((): boolean => (this.buttonDisable = false))
				)
				.subscribe(
					(data: AccessTokens): void => {
						this.messageService.showToaster('s_4', 'twoFa');
						this.authTokenService.successGetRefreshedToken(data);
						this.activeModal.close('SUCCESS_LOGIN');
					},
					({ error }): void => {
						const { errorTitle, errorMessage } = error;
						this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					}
				);
		}
	}

	moveToResetModal(): void {
		if (!this.buttonDisable) {
			this.activeModal.close('LAUNCH_RESET');
		}
	}

	onDismiss(): void {
		if (!this.buttonDisable) {
			this.activeModal.dismiss();
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/2fa/modals/two-fa-login-modal/two-fa-login-modal.ts